module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "persistent": "",
      "scrollable": "",
      "width": "1000px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      Edit Content Script for @" + _vm._s(_vm.item ? _vm.item.userHandle : '') + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "height": "700px",
      "margin-top": "20px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.restoreTemplate
    }
  }, [_vm._v("Load Default")])], 1)], 1)], 1), _vm._v(" "), _c('sun-editor', {
    staticStyle: {
      "height": "650px"
    },
    attrs: {
      "content": _vm.editContent
    },
    on: {
      "contentChanged": _vm.changeContent
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": !_vm.editContent
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-227e13ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/CreatorConcept/ContentScriptEditDialog.vue
// module id = 2037
// module chunks = 0